// extracted by mini-css-extract-plugin
export default {"dark":"UpdateContactStatus_dark__dlFn6","updateContactSection":"UpdateContactStatus_updateContactSection__xwrCh","formGroup":"UpdateContactStatus_formGroup__2Pz3x"};